export { default as EmailTemplatesEdit } from './EmailTemplatesEdit';
export { default as EmailTemplatesList } from './EmailTemplatesList';